module.exports = __webpack_public_path__ + "img/g-tsp.869b2455.png";